(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/router.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.Router = Backbone.Router.extend({
    routes: svs.core.data.routes,

    welcome: function() {
      this.spela();
    },

    spela: function(drawNumber, matchNum) {
      matchNum = matchNum || '1';
      svs.maltipset.collections.coupons.setCurrentCoupon(drawNumber);
      svs.maltipset.app.skeleton
        .getRegion('mainRegion')
        .show(new svs.maltipset.views.Play({ matchNum: matchNum }));
      if (svs.core.detect.formfactor.mobile()) {
        var urlEventNumber;
        var match;
        var eventDescription;
        var drawNum = parseInt(drawNumber, 10);
        var matchList;
        var productId;
        if (window.location.pathname.split('/').length > 3) {
          urlEventNumber = parseInt(window.location.pathname.split('/')[3].split('-')[0], 10);
        }

        if (urlEventNumber) {
          this.bigstatController = new svs.maltipset.controllers.BigStatController();

          drawNum = parseInt(drawNumber, 10);

          matchList = svs.maltipset.collections.draws.models[
            svs.maltipset.collections.draws.currentDrawIndex
          ].get('matchList').models;

          for (var index = 0; index < matchList.length; index++) {
            if (matchList[index].get('eventNumber') == urlEventNumber) {
              match = matchList[index].get('match');
              eventDescription = matchList[index].get('eventDescription');
            }
          }

          productId = svs.maltipset.collections.draws.models[
            svs.maltipset.collections.draws.currentDrawIndex
          ].get('productId');

          svs.core.data.title = svs.core.data.title || {};
          if (eventDescription) {
            svs.core.data.title = _.extend(svs.core.data.title, {
              eventDescription: eventDescription
            });
          }

          if (match && drawNum && matchList && productId) {
            this.bigstatController.showBigNav({
              match: match,
              drawNumber: drawNum,
              productId: productId,
              matchList: matchList
            });
          }
        }

        if (urlEventNumber == undefined && document.getElementById('maltipset-nav') && svs.core.detect.formfactor.mobile()) {
          svs.components.sportinfo.bigstat.unmountBigStatModal(document.getElementById('maltipset-nav'));
          svs.core.data.title = svs.core.data.title || {};
          svs.core.data.title = _.extend(svs.core.data.title, {
            eventDescription: ''
          });
          svs.components.contextualMenu.toggleVisibility();
        }
      }
    }
  });
})(Backbone, _, svs);


 })(window);